import { render, staticRenderFns } from "./HspUserAdminLayout.vue?vue&type=template&id=508a0912"
import script from "./HspUserAdminLayout.vue?vue&type=script&lang=js"
export * from "./HspUserAdminLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports